import { Field, useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import Label from "../../label/label";

interface ButtonConfigEditStepProps {
    onBack: (event: any) => void | undefined;
    onNext: (event: any) => void | undefined;
}
const ButtonConfigEditStep: FC<ButtonConfigEditStepProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const { errors, values, setFieldValue, isValid, validateForm } = useFormikContext<any>();
    const [enableNext, setEnableNext] = useState<boolean>(false);

    useEffect(() => {
        setEnableNext(values.type && values.buttonText);
    }, [values, isValid])

    return (<>
        <div className="flex flex-col pr-3 h-full relative">

            <div className="flex flex-row pt-3">
                <div className="flex flex-col flex-1">
                    <div className="flex flex-row justify-between">
                        <Label
                            htmlFor="buttonName"
                            className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.buttonText)}:</Label>
                
                    </div>
                    <Field
                        type="text"
                        name="buttonText"
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    />
                </div>
            </div>

            <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
                
                <div className="flex flex-row justify-end mt-4 pl-3">
                    <button
                        className={`py-1 px-5 secondary  ${!enableNext ? 'secondary-disabled cursor-not-allowed' : 'text-white bg-portal-blue-primary-shade2'}`}
                        type="button"
                        onClick={(e) => { enableNext && onNext({ ...e, type: values.type, buttonText: values.buttonText }) }}>{translate.byKey(TranslationKeys.next)}</button>
                </div>
            </div>

        </div>
    </>
    )
}

export default ButtonConfigEditStep;